import { render, staticRenderFns } from "./AppIntegerAnswer.vue?vue&type=template&id=5e5fa773&scoped=true"
import script from "./AppIntegerAnswer.vue?vue&type=script&lang=ts"
export * from "./AppIntegerAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppIntegerAnswer.vue?vue&type=style&index=0&id=5e5fa773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fa773",
  null
  
)

export default component.exports